import type { JSX } from 'react';
import { AvailabilityAlertsEventsPanel } from '@/components/dashboard/availabilityAlerts/AvailabilityAlertsEventsPanel';
import { AvailabilityAlertsSubscribersPanel } from '@/components/dashboard/availabilityAlerts/AvailabilityAlertsSubscribersPanel';

export function AvailabilityAlertsManager(): JSX.Element {
  return (
    <div className="flex flex-col gap-xl">
      <AvailabilityAlertsSubscribersPanel />
      <AvailabilityAlertsEventsPanel />
    </div>
  );
}
